import React from 'react';
import { IconProps } from '../types';
const MinecraftGhastTear: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="4" width="1" height="1" fill="rgba(56, 88, 88, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(56, 88, 88, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(181, 219, 219, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(159, 195, 195, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(56, 88, 88, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(207, 241, 241, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(181, 219, 219, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(56, 88, 88, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(181, 219, 219, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(207, 241, 241, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(207, 241, 241, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(159, 195, 195, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(56, 88, 88, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(207, 241, 241, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(207, 241, 241, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(159, 195, 195, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(56, 88, 88, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(181, 219, 219, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(181, 219, 219, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(159, 195, 195, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(181, 219, 219, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(159, 195, 195, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(55, 74, 74, 255)" />
</svg>);
export default MinecraftGhastTear;